import { useAuthUser } from "../features/authContext";

export function useAdminStatus() {
	const user = useAuthUser();
	if (!user) {
		return false;
	}
	return user.isAdmin;
}
